
<div class="index-cards-view">
  <align flex collapse-end direction="flex-start">
    <shared-filters
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <direction-sort-options
      :sort.sync="sort"
      :direction.sync="direction"
      :options="sortOptions"
    />
  </align>

  <filter-results
    :is-filtering="isFiltering"
    :filters="filters"
    :results="numResults"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template>
      <div class="list">
        <card-list-item
          v-for="card in cards"
          :key="card.id"
          :to="{ query: { ...$route.query, cardId: card.id } }"
          :card="card"
          :fields="itemFields"
          as="router-link"
        >
          <icon
            v-if="(!card.outlierIndex && card.numSales > 1) || indexName === 'outlier'"
            v-tooltip="{ content: 'This card qualifies to be included in the index calculations', delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
            name="assessment"
            class="card-qualifier-icon"
          />
        </card-list-item>
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>
  </div>
</div>
